import { TableProps } from '@amzn/awsui-components-react-v3/polaris/table/interfaces';
import { isValidMidwayUser } from 'src/commons/validationUtils';
import { getPhoneToolLink } from 'src/commons/common';
import { GladstoneRequestItem } from 'aws-sdk/clients/awsdatalakegladstonelambda';

export const iamColumnDefinition = (isIncomingRequests): TableProps.ColumnDefinition<any>[] => [
  {
    id: 'catalogId',
    header: 'Catalog ID',
    cell: (item) => item.catalogId,
    minWidth: '125px',
    sortingField: 'catalogId',
  },
  {
    id: 'databaseName',
    header: 'Database name',
    cell: (item) => item.databaseName,
    minWidth: '200px',
    sortingField: 'databaseName',
  },
  {
    id: 'tableName',
    header: 'Table name',
    cell: (item) => item.tableName,
    minWidth: '200px',
    sortingField: 'tableName',
  },
  isIncomingRequests
    ? {
        id: 'requestedBy',
        header: 'Requested by',
        cell: (item) => item.groupRequestedBy,
        minWidth: '100px',
        sortingField: 'groupRequestedBy',
      }
    : {
        id: 'requestedTo',
        header: 'Requested to',
        cell: (item) => item.groupRequestedTo,
        minWidth: '100px',
        sortingField: 'groupRequestedTo',
      },
  {
    id: 'requestedTime',
    header: 'Requested time',
    cell: (item) => item.timeOfRequest,
    minWidth: '100px',
    sortingField: 'timeOfRequest',
  },
  {
    id: 'requester',
    header: 'Requester',
    cell: (item) => (isValidMidwayUser(item.requester) ? getPhoneToolLink(item.requester) : item.requester),
    minWidth: '100px',
    sortingField: 'requester',
  },
];

export const extractAccessManagementInfoFromRequest = (item: GladstoneRequestItem, transform) => {
  let allSimTicketLinks = [];
  let uniqueApprovalWorkflowIds = new Set<string>();
  let approvals = [];
  let uniqueRequestContextIds = new Set<string>();
  let requestContextIds = [];
  if (item.additionalMetadata != undefined && item.additionalMetadata.accessManagementInfoList != undefined) {
    for (const accessManagementInfo of item.additionalMetadata.accessManagementInfoList) {
      if (accessManagementInfo.simTicketLinks) {
        allSimTicketLinks = allSimTicketLinks.concat(
          accessManagementInfo?.simTicketLinks?.map((simTemplate) => {
            return {
              simTemplateLink: simTemplate.simTemplateLink,
              simTemplateName: simTemplate.simTemplateName,
              simTicketLink: simTemplate.simTicketLink,
            };
          }),
        );
      }
      if (
        accessManagementInfo.approvalTemplateId &&
        !uniqueApprovalWorkflowIds.has(accessManagementInfo.approvalWorkflowId)
      ) {
        uniqueApprovalWorkflowIds.add(accessManagementInfo.approvalWorkflowId);
        approvals = approvals.concat({
          approvalTemplateId: accessManagementInfo.approvalTemplateId,
          approvalWorkflowId: accessManagementInfo.approvalWorkflowId,
          approvalWorkflowStatus: accessManagementInfo.approvalWorkflowStatus,
          approvalDecisionTime: accessManagementInfo.approvalDecisionTime,
          omniTemplateId: accessManagementInfo.templateId,
          omniResourceId: accessManagementInfo.resourceId,
        });
      }
    }
  }
  if (item.additionalMetadata != undefined && item.additionalMetadata.accessRequestWorkflowInfoList != undefined) {
    for (const arw of item.additionalMetadata.accessRequestWorkflowInfoList) {
      if (!!arw.approvalTemplateId && !uniqueApprovalWorkflowIds.has(arw.approvalWorkflowId)) {
        uniqueApprovalWorkflowIds.add(arw.approvalWorkflowId);
        approvals = approvals.concat({
          approvalTemplateId: arw.approvalTemplateId,
          approvalWorkflowId: arw.approvalWorkflowId,
          approvalWorkflowStatus: arw.approvalWorkflowStatus,
          approvalDecisionTime: arw.approvalDecisionTime,
          omniTemplateId: arw.templateId,
          omniResourceId: arw.resourceId,
          omniTemplateType: arw.templateType,
        });
      }
      if (!!arw.requestContextId && !uniqueRequestContextIds.has(arw.requestContextId)) {
        uniqueRequestContextIds.add(arw.requestContextId);
        requestContextIds.push(arw.requestContextId);
      }
    }
  }
  if (allSimTicketLinks.length > 0) {
    transform['simTickets'] = allSimTicketLinks;
  }
  if (approvals.length > 0) {
    transform['approvalsWorkflow'] = approvals;
  }
  if (requestContextIds.length > 0) {
    transform['requestContextIds'] = requestContextIds;
  }
  if (item.additionalMetadata != undefined && item.additionalMetadata.dataZoneMetadata != undefined) {
    transform['dataZoneAssetId'] = item.additionalMetadata.dataZoneMetadata.assetId;
    transform['dataZoneProjectId'] = item.additionalMetadata.dataZoneMetadata.projectId;
  }
  return transform;
};
